import { Typography } from '@mui/material'
import { Printer, Check } from 'react-feather'
import theme from 'src/styles/theme'
import styled from 'styled-components'

export const Container = styled.div`
    height: 660px;
    display: flex;
    align-items: center;
    justify-content: center;
`

export const Section = styled.div`
    background: ${theme.colors.gray2};
    width: auto;
    border-radius: 8px;
`

export const SectionLabel = styled.div<{ backgroundColor: string }>`
    background: ${(props) => props.backgroundColor ?? theme.colors.blue};
    display: flex;
    flex-direction: row;
    gap: 16px;
    padding: 16px;
    border-radius: 8px 8px 0 0;
`

export const SectionLabelTitle = styled(Typography)`
    color: ${theme.colors.white};
`

export const PrinterIcon = styled(Printer)`
    color: ${theme.colors.white};
`

export const CheckIcon = styled(Check)`
    color: ${theme.colors.white};
`

export const SectionBody = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
    padding: 16px 32px;
    border-radius: 0 0 8px 8px;
`

export const LinkButton = styled.button`
    background: none;
    color: blue;
    border: none;
    padding: 0;
    font: inherit;
    text-decoration: underline;
    cursor: pointer;

    &:hover {
        color: darkblue;
    }
`
